import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Select                   } from 'src/app/interface/select/select';
import { LoadingManager           } from 'src/app/managers/loading/loading.manager';
import { HandlerManager           } from 'src/app/managers/handler/handler.manager';
import { SessionManager           } from 'src/app/managers/session/session.manager';
import { User                     } from 'src/app/beans/login/user/user.bean';
import { Device                   } from 'src/app/beans/device/device.bean';
import { Site                     } from 'src/app/beans/site/site.bean';
import { MatSelectChange } from '@angular/material/select';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';

@Component({
  selector: 'device-select',
  templateUrl: './device.select.html',
  styleUrls: ['./device.select.scss']
})

export class DeviceSelect implements OnInit, Select
{
  @Input( 'site' ) set _site( site: Site )
  {
    if( site ) this.init( site.id )
  }

  @Input('type') type: number = 0
  @Input() select_name: string  = "select.device.label.single"

  @Input() enabled : number  = 1


  @Input() autoSelectFirst: boolean = false
  @Output() change: EventEmitter<Device> = new EventEmitter<Device>()

  values      : Device[]
  currentValue: Device

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _pipe: PipeManager
  ) {}

  ngOnInit()
  {}

  async init( siteId: number )
  {
    if( this.type == 40)
    {
      this.type = 10
      let codino = await this.retriveValues( siteId )

      this.type = 30
      let summary = await this.retriveValues(siteId)

      this.values = codino.concat(summary)
      this.type = 40
    }
    else this.values = await this.retriveValues( siteId )

    this.values.sort( (a,b) => this._pipe.sorting().sort(a.name.toLowerCase(), b.name.toLowerCase()))
    this.values.sort( (a,b) => this._pipe.sorting().sort(a.name.length, b.name.length))
    this.values.sort( (a,b) => this._pipe.sorting().sort(a.type, b.type))

    if( this.values.length == 0 )
      this.change.emit( null )

    if(this.setSavedValue(JSON.parse(localStorage.getItem('device-select')))) {}
    else if (this.autoSelectFirst) this.selectFirst()
  }

  getSelectedValue()
  {
    return this.currentValue
  }

  setSelectedValue( value: Device ): void
  {
    this.currentValue = value
    this.change.emit(value)
  }

  clearSelectedValue(): void
  {
    this.setSelectedValue(undefined)
  }

  async retriveValues( siteId: number )
  {
    const user  = this._session.user().get()

    if ( !User.isKind( user ) ) return // TODO handle user incorrect

    this._loader.start()

    let response = null

    if ( this.type !=  0 )  response = await this._handler.device().list(( user as User ).token, siteId, this.type, this.enabled )
    else                    response = await this._handler.device().list(( user as User ).token, siteId, null, this.enabled )

    this._loader.stop()

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as Device[]
  }

  selectFirst (): void
  {
    if ( this.values && this.values.length > 0 ) {
      this.setSelectedValue(this.values[0])
    }
  }

  selectElement( el: Device ): void
  {
    const find = this.searchElement( el )
    if ( find )  this.setSelectedValue(find)
  }

  searchElement( el: Device ): Device
  {
    if ( !this.values ) return undefined

    return this.values.find ( ( dev ) => dev.id == el.id )
  }

  onChange(slChange: MatSelectChange)
  {
    this.setSelectedValue(slChange.value)
    localStorage.setItem('device-select', JSON.stringify(slChange.value))

  }

  setSavedValue(device: Device)
  {
    var control = false
    if( this.values && device )
    {
      this.values.forEach(element => {
        if(element.id == device.id)
        { this.setSelectedValue(element)
          control = true
        }
      });
    }
    return control
  }

  async refreshData(site: Site)
  {
    await this.init(site.id)
  }
}
